export function translateStatic(key) {
  const [, text] = key.split(':');
  return text;
}
